import { Behavior } from '@dia-ui/abstract';

/**
 * handles mailto links by chosen target
 * and makes target blank mailto work in all browsers!
 */
@Behavior('mailto-handler')
export class MailtoHandler {
  element: any;

  href: string;
  target: string;

  // This is called only once, given the `element` that the behavior is attached to.
  constructor(element) {
    this.element = element;

    this.href = this.element.getAttribute("href") || undefined;
    this.target = this.element.getAttribute("target") || 'mail';

    // no href? WT*? we cant handle a link without a href
    if (this.href === undefined) {
      console.error("mailto-handler: ", this.element, " no href defined to handle!");
    }

    // prevent initial event and handle chosen target in new window
    this.element.addEventListener("mousedown", (event)=> {
      event.preventDefault();
      window.open(this.href, this.target);
    });
  }

  // This is called any time the associated `element` is appended into the
  // DOM, passed in the `element`
  connectedCallback(){
  }

  // This is called any time the associated `element` is removed from the DOM,
  // passed in the `element`.
  disconnectedCallback() {
  }

  // As with custom elements, define which attributes of the associated
  // element that the behavior should react to.
  /*static observedAttributes = [
    'data-draggable-events',
    'data-draggable-selector'
  ];*/

  // This is called any time any of the `observedAttributes` of the associated
  // element have been changed, just like with Custom Elements but with the
  // additional passed in `element`.
  // attributeChangedCallback(attributeName, oldValue, newValue, element) {}

  // There is one additional API, unlike with Custom Elements. If `static
  // awaitElementDefined` is `true`, then the behavior will not be
  // instantiated and connected until its host element is defined and upgraded
  // (that is, if the host element is possibly a custom element, having a
  // hyphen in its name). If the host element has no hyphen in its name, then
  // this does not apply, and the behavior will be created and connected
  // immediately without waiting. If a possibly-custom element is removed
  // before it is defined, then a behavior will not be created and connected
  // at all (waiting will have been canceled).
  static awaitElementDefined = true // Default is false.
}
